<template>
  <div>
    <mdb-modal :show="visible" @close="onClose">
      <mdb-modal-header>
        <mdb-modal-title>Submit Withdrawal Batch</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
        <mdb-input label="Batch Name" outline v-model="text" />
      </mdb-modal-body>
      <mdb-modal-footer>
          <mdb-btn v-if="text" size="sm" @click="onSubmit" color="primary">Submit Withdrawal</mdb-btn>
          <mdb-btn @click="onClose" size="sm" color="danger">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalFooter, mdbBtn, mdbModalBody, mdbInput} from 'mdbvue';

  export default {
    components: {
      mdbModal, mdbInput,
      mdbModalHeader,
      mdbModalTitle,
      mdbModalFooter,
      mdbBtn,
      mdbModalBody
    },
    props: ['visible', 'close', 'submit', 'selected_records'],
    data: ()=>({
        text: ""
    }),
    methods: {
      onSubmit(){
        this.submit?this.submit(this.text):null;
        this.onClose();
      },
      onClose(){
          this.text="";
          this.close();
      }
    },
  };
</script>

<style scoped>
</style>